module.exports = __webpack_public_path__ + "img/q3.cc45e856.png";